// assets/infinite-scroll.js
document.addEventListener('DOMContentLoaded', () => {
  if (!window.location.pathname.includes('/search') && !window.location.pathname.includes('/collections/') && !window.location.pathname.includes('/collections')) return;


  const grid      = document.querySelector('#product-grid');          // kontainer kartu
  const spinner = document.querySelector('.loading-spinner'); // GANTI ini
  const noMoreBox = document.querySelector('.no-more-products');

  if (!grid) return;                         // amankan kalau selektor tak ditemukan

  let page        = 2;                       // mulai dari halaman ke-2
  let loading     = false;
  let stopLoading = false;                   // true = tidak ada halaman berikutnya

  // helper
  const show = el => el && (el.style.display = 'flex');
  const hide = el => el && (el.style.display = 'none');

  // muat produk berikutnya
  async function loadNextPage() {
    if (loading || stopLoading) return;

    // cukup dekat ke dasar? (200 px threshold)
    if (window.innerHeight + window.scrollY < document.body.offsetHeight - 200) return;

    loading = true;
    show(spinner);

    // susun URL dengan parameter page
    const params = new URLSearchParams(window.location.search);
    params.set('page', page);
    const url = `${window.location.pathname}?${params.toString()}`;

    try {
      const res  = await fetch(url);
      const html = await res.text();
      const doc  = new DOMParser().parseFromString(html, 'text/html');

      // ambil SEMUA elemen anak langsung di #product-grid
      const newCards = doc.querySelectorAll('#product-grid > *');

      if (newCards.length) {
        newCards.forEach(card => grid.appendChild(card));
        page += 1;                           // siap ke halaman berikutnya
      } else {
        stopLoading = true;                  // tidak ada kartu → hentikan
        show(noMoreBox);
      }
    } catch (err) {
      console.error('Infinite-scroll error:', err);
    } finally {
      loading = false;
      hide(spinner);
    }
  }

  // pasang listener
  window.addEventListener('scroll', loadNextPage);
});
